// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reviewsio--rating-snippet {
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Common/components/shared.bundle/styles/reviewsio-ratings.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF","sourcesContent":[".reviewsio--rating-snippet {\n  margin-top: 10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
